import { render, staticRenderFns } from "./ClamMstPopupTableInfo4.vue?vue&type=template&id=6bb70a8a&"
import script from "./ClamMstPopupTableInfo4.vue?vue&type=script&lang=js&"
export * from "./ClamMstPopupTableInfo4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports